import { useDebounce } from 'react-use';
import { noop } from 'lodash';

import { VisitUpdateCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { VisitFormBean, VisitFormController } from './visitForm.types';
import { createCommonVisitParameters } from './visitForm.utils';

const AUTOSAVE_DELAY_THRESHOLD = 500;

type VisitFormAutoSaveProps = {
   readonly controller: VisitFormController;
   readonly visitId: number;
};

export const VisitFormAutoSave = (props: VisitFormAutoSaveProps): null => {
   const { procedures } = props.controller.watch(['procedures.value']);

   const { execute: updateVisit } = useCqrsCommand<void, VisitFormBean>(
      (parameters) => {
         const command = new VisitUpdateCommand();
         command.visitId = props.visitId;
         command.commonVisitParameters = createCommonVisitParameters(parameters);
         return command;
      },
      {
         onUnexpectedError: noop,
      }
   );

   useDebounce(
      () => {
         if (props.controller.formState.isDirty) {
            props.controller.handleSubmitDraft(updateVisit)();
         }
      },
      AUTOSAVE_DELAY_THRESHOLD,
      [JSON.stringify(procedures?.value)]
   );

   return null;
};
